import Container from '@/components/shared/Container'
import Content from '@/components/shared/Content'
import React from 'react'
import styles from '@/styles/donate/Donate.module.css'
import CommitteeLogo from '@/public/ehf-committee.png'
import Image from 'next/image';
import Link from 'next/link'
import CategoryBanner from '@/components/shared/CategoryBanner'
import Script from 'next/script'
import Head from 'next/head'
import { getBackgroundFromPage } from '@/sanity/sanity.query'

export async function getStaticProps() {
  const background = await getBackgroundFromPage('Donate')
  return {
    props: {
      background
    },
    revalidate: 60, // Regenerate the page every 60 seconds
  };
}

const Donate = ({ background }) => {
  return (
    <>
      <Head>
        <title>Donate | Edward Hosharian Foundation</title>
        <meta name="description" content="Support the Edward Hosharian Foundation by making a donation. Your contribution helps us continue our mission of promoting music education and cultural heritage through scholarships, concerts, and community events. Learn how you can make a difference today."></meta>
      </Head>
      <Container background={background}>
        <CategoryBanner backHref='/' backText='Home' heading='Donate' description='Help us support the future of Armenian musicians' />
        <Content>
          <div className={`${styles.intro}`}>
            <p className={`${styles.lead}`}>
              Your gift funds scholarships for Armenian music students across the United States.
            </p>
            <Link href='/scholarship' className={`${styles.link}`}>Meet our scholarship recipients</Link>
          </div>

          <div className={`${styles.notice}`}>
            <Image src={CommitteeLogo} alt="Edward Hosharian Foundation committee logo" width={30} height={62} />
            {/* the zero-width non-joiner stops Manrope drawing "(c)" as a copyright sign */}
            <p>
              The Edward Hosharian Foundation is a Section 501({'\u200c'}c)(3) charitable organization
              {' '}<span className={`${styles.nowrap}`}>(EIN 30-0545772)</span>.
              {' '}<strong>All donations are tax deductible.</strong>
            </p>
          </div>

          <div className={`${styles.grid}`}>
            <section className={`${styles.card}`}>
              <h2 className={`${styles.heading}`}>Donate online</h2>
              <p className={`${styles.subheading}`}>By credit card through Donorbox.</p>
              <div className={`${styles.widget}`}>
                <Script src="https://donorbox.org/widget.js" paypalexpress="false"></Script>
                <iframe
                  src="https://donorbox.org/embed/ehfoundation?default_interval=o"
                  name="donorbox"
                  title="Donation form"
                  allowpaymentrequest="allowpaymentrequest"
                  seamless="seamless"
                  frameBorder="0"
                  scrolling="no"
                  height="900px"
                  width="100%"
                  style={{ width: '100%', maxHeight: 'none' }}
                  allow="payment"
                ></iframe>
              </div>
            </section>

            <section className={`${styles.card}`}>
              <h2 className={`${styles.heading}`}>Donate by check</h2>
              <dl className={`${styles.check}`}>
                <dt>Make checks payable to</dt>
                <dd>Edward Hosharian Foundation</dd>
                <dt>Mail to</dt>
                <dd>
                  <address>
                    Edward Hosharian Foundation<br />
                    PO Box 2577<br />
                    Montebello, CA 90640
                  </address>
                </dd>
              </dl>
              <p className={`${styles.questions}`}>
                Questions about giving? <Link href='/contact' className={`${styles.link}`}>Contact us</Link>
              </p>
            </section>
          </div>
        </Content>
      </Container>
    </>
  )
}

export default Donate;
